import { TReduxActions } from '../../types/redux/actions';
import { EStatusLoad, IStatusState } from '../../types/redux/status';
import { EStatusActions } from '../../actions/status';

export const defaultState: IStatusState = {
  statusLoad: EStatusLoad.init,
  modalOpen: false,
  data: [],
};

export function statusReducer(state: IStatusState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EStatusActions.TOGGLE_STATUS_STATUS:
      return {
        ...state,
        statusLoad: action.payload,
      };

    case EStatusActions.TOGGLE_STATUS_MODAL:
      return {
        ...state,
        modalOpen: action.payload,
      };

    case EStatusActions.SET_STATUS_LIST:
      return {
        ...state,
        data: action.payload,
      };

    case EStatusActions.SET_MY_HOME_STATUS:
      return {
        ...state,
        currentStatus: action.payload,
      };

    default:
      return state;
  }
}
